// extracted by mini-css-extract-plugin
export default {"contentWrapper":"app_contentWrapper__zzOcy"};